import { RESET_STATE } from 'store/global/actions';

import { LOAN_BUNDLE_HISTORY_ACTION_TYPE } from '../actions';

// `isSettled` (not "loaded") distinguishes "no bundles delivered" from "not fetched yet" — an
// empty `items` array means both, so a consumer deriving an authoritative status from it
// (PathToSubmission's Disclosures step) would report "not sent" for the whole multi-second window
// before this fetch — one of the last of the loan's ~46 requests — resolves. Set on settle,
// success or failure, so a failed fetch cannot leave a consumer waiting forever.
const initialState = {
  items: [],
  isSettled: false,
};

const loanBundleHistoryReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case LOAN_BUNDLE_HISTORY_ACTION_TYPE.GET_HISTORY:
      return { items: payload || [], isSettled: true };

    // A failed fetch is still a settled one: leaving `isSettled` false would strand consumers on
    // a permanent loading state, which is worse than deriving from an empty list.
    case LOAN_BUNDLE_HISTORY_ACTION_TYPE.GET_HISTORY_REJECTED_STATUS:
      return { ...state, isSettled: true };

    case RESET_STATE:
      return initialState;

    default:
      return state;
  }
};

export default loanBundleHistoryReducer;
